import ApplyConversationActionRequest from 'owa-service/lib/contract/ApplyConversationActionRequest';
import ApplyConversationActionResponseMessage from 'owa-service/lib/contract/ApplyConversationActionResponseMessage';
import ConversationAction from 'owa-service/lib/contract/ConversationAction';
import InferenceClassification from 'owa-service/lib/contract/InferenceClassification';
import applyConversationActionRequest from 'owa-service/lib/factory/applyConversationActionRequest';
import conversationAction from 'owa-service/lib/factory/conversationAction';
import itemId from 'owa-service/lib/factory/itemId';
import applyConversationActionOperation from 'owa-service/lib/operation/applyConversationActionOperation';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';

function createConversationAction(
    conversationId: string,
    inferenceClassification: InferenceClassification
): ConversationAction {
    return conversationAction({
        Action: 'SetInferenceClassificationState',
        ConversationId: itemId({ Id: conversationId }),
        InferenceClassification: inferenceClassification,
    });
}

/**
 * Configure the request body
 * @param conversationIds the conversation ids
 * @param inferenceClassification the inferenceClassification value to update
 * @returns an ApplyConversationActionRequest
 */
function configureRequestBody(
    conversationIds: string[],
    inferenceClassification: InferenceClassification
): ApplyConversationActionRequest {
    const conversationActions = conversationIds.map(conversationId =>
        createConversationAction(conversationId, inferenceClassification)
    );

    return applyConversationActionRequest({
        ConversationActions: conversationActions,
    });
}

/**
 * Set InferenceClassification service
 * @param conversationIds the conversation ids
 * @param inferenceClassification the inferenceClassification value to update
 * @return the ApplyConversationActionResponseMessage
 */
export function setConversationInferenceClassificationService(
    conversationIds: string[],
    inferenceClassification: InferenceClassification
): Promise<ApplyConversationActionResponseMessage> {
    const requestBody = configureRequestBody(conversationIds, inferenceClassification);

    return applyConversationActionOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    })
        .then(response => {
            return response.Body.ResponseMessages.Items[0];
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
